import React from 'react';
import './DashboardPage.css';

const DashboardPage = () => {
  const stats = [
    { title: 'Total Products', value: '1,234', icon: '📦', color: '#667eea' },
    { title: 'Active Orders', value: '89', icon: '📋', color: '#f093fb' },
    { title: 'Revenue', value: '$45,678', icon: '💰', color: '#4facfe' },
    { title: 'Customers', value: '567', icon: '👥', color: '#43e97b' },
  ];

  const recentActivities = [
    { id: 1, action: 'New product added', time: '2 minutes ago', type: 'product' },
    { id: 2, action: 'Order #1234 completed', time: '15 minutes ago', type: 'order' },
    { id: 3, action: 'Customer registration', time: '1 hour ago', type: 'customer' },
    { id: 4, action: 'Price update', time: '2 hours ago', type: 'price' },
  ];

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h2>Welcome to AESOP PRICING Dashboard</h2>
        <p>Here's what's happening with your business today</p>
      </div>

      {/* Stats Cards */}
      <div className="stats-grid">
        {stats.map((stat, index) => (
          <div key={index} className="stat-card" style={{ borderLeftColor: stat.color }}>
            <div className="stat-icon" style={{ backgroundColor: stat.color }}>
              {stat.icon}
            </div>
            <div className="stat-content">
              <h3 className="stat-value">{stat.value}</h3>
              <p className="stat-title">{stat.title}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Recent Activities */}
      <div className="dashboard-section">
        <h3>Recent Activities</h3>
        <div className="activities-list">
          {recentActivities.map((activity) => (
            <div key={activity.id} className="activity-item">
              <div className="activity-icon">
                {activity.type === 'product' && '📦'}
                {activity.type === 'order' && '📋'}
                {activity.type === 'customer' && '👥'}
                {activity.type === 'price' && '💰'}
              </div>
              <div className="activity-content">
                <p className="activity-action">{activity.action}</p>
                <p className="activity-time">{activity.time}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Quick Actions */}
      <div className="dashboard-section">
        <h3>Quick Actions</h3>
        <div className="quick-actions">
          <button className="action-button">
            <span className="action-icon">➕</span>
            <span>Add Product</span>
          </button>
          <button className="action-button">
            <span className="action-icon">📊</span>
            <span>View Reports</span>
          </button>
          <button className="action-button">
            <span className="action-icon">⚙️</span>
            <span>Settings</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default DashboardPage; 